export default class GeoFilterController {

  /**
   * @author Markus Hölzle <m.hoelzle@andersundsehr.com>
   * @param $filterForm
   * @param googleMap
   * @param settings
   */
  constructor($filterForm, googleMap, settings) {
    this.$filterForm = $filterForm;
    this.googleMap = googleMap;
    this.geoCoder = new google.maps.Geocoder();

    this.settings = {};
    if (typeof settings !== 'undefined') {
      $.extend(this.settings, settings);
    }

    this.viewPortCache = {};
    this.mayZoomOut = false;
    this.lastCountry = '';

    this.initListener();
    this.sortCountrySelect();
  }

  /**
   * @return {void}
   */
  initListener() {
    var self = this;
    self.$filterForm.submit(() => {
      self.submitFilterForm();
      return false;
    });
    self.$filterForm.find('select, input').change((event) => {
      if ($(event.target).filter('.js-max-results-filter')) {
        self.toggleFormFields();
      }
      self.$filterForm.submit();
    });
    $('.js-geo-filter-city-clone, #productGroup, #productGroupCategory').change(() => {
      self.mayZoomOut = true;
    });
    $('#country').change(() => {
      $('#city').val('').closest('fieldset').addClass('fieldset--hide');
    });
    $('.js-geo-filter-city-clone').closest('fieldset').find('button').click(() => {
      self.mayZoomOut = true;
    });
  }

  /**
   * @return {void}
   */
  sortCountrySelect() {
    var $select = $('.js-geo-filter-country-clone');
    var $options = $select.find('option');

    $options.sort((a, b) => {
      return a.text.toUpperCase().localeCompare(b.text.toUpperCase());
    });

    $select.empty().append($options);
  }

  /**
   * @return {void}
   */
  toggleFormFields() {
    var self = this;
    var currentValue = self.$filterForm.find('.js-geo-filter-country-clone').val();
    var maxResults = parseInt(self.$filterForm.find('.js-geo-filter-country-clone option[value="' + currentValue + '"]').attr('data-max-results'), 10);
    var partnerList = $('.js-partner-list');
    var partnerMap = $('.js-partner-map');
    var partnerContentmap = $('.js-partner-contentmap');

    // Clear zip/city field if country changed
    if (this.lastCountry !== currentValue) {
      self.$filterForm.find('.js-geo-filter-city-clone').val('');
      $('.js-geo-filter-city').val('');
      this.lastCountry = currentValue;
    }

    if (self.$filterForm.hasClass('js-do-not-show')) {
      self.$filterForm.hide();
    } else {
      self.$filterForm.show();
    }
    if (isNaN(maxResults) || partnerList.hasClass('js-do-not-show')) {
      partnerList.css({ width: '0', height: '0' });
      partnerContentmap.css({ width: '100%' });
      partnerMap.css({ width: partnerContentmap.width() + 'px' });
    } else {
      if ($(window).width() <= 768) {
        partnerList.css({ width: '100%', height: '500px' });
        partnerContentmap.css({ width: '100%' });
      } else {
        partnerList.css({ width: '400px', height: '750px' });
        partnerContentmap.css({ width: 'calc(100% - 400px)' });
      }
      partnerMap.css({ width: partnerContentmap.width() + 'px' });
      self.$filterForm.find('input').each((index, elem) => {
        var $element = $(elem);
        var minResultsForElement = parseInt($element.attr('data-min-results'), 10);
        if (!isNaN(minResultsForElement) && minResultsForElement !== 0) {
          var $fieldSet = $element.closest('fieldset');
          if (maxResults >= minResultsForElement) {
            if ($fieldSet.hasClass('fieldset--hide')) {
              $fieldSet.removeClass('fieldset--hide');
            }
          } else {
            $element.val('');
            if (!$fieldSet.hasClass('fieldset--hide')) {
              $fieldSet.addClass('fieldset--hide');
            }
          }
        }
      });
    }
  }

  /**
   * @return {void}
   */
  submitFilterForm() {
    var self = this;
    $('.js-partner-productGroup').val($('.js-partner-productGroup-clone').val());
    $('.js-partner-productGroupCategory').val($('.js-partner-productGroupCategory-clone').val());

    var city = self.$filterForm.find('.js-geo-filter-city-clone').val();
    $('.js-geo-filter-city').val(city);

    var countryIsoCode = self.$filterForm.find('.js-geo-filter-country-clone').val();
    $('.js-geo-filter-country').val(countryIsoCode);

    if (city || countryIsoCode) {
      if (countryIsoCode === 'more') {
        if (city === '') {
          self.googleMap.setZoom(2);
        } else {
          self.getCityViewport(city, (viewport) => {
            self.googleMap.fitBounds(viewport);
            self.googleMap.setZoom(self.googleMap.getZoom());
          });
        }
      } else {
        self.getCountryAndCityViewport(countryIsoCode, city, (viewport) => {
          self.googleMap.fitBounds(viewport);
          self.googleMap.setZoom(self.googleMap.getZoom());
        });
      }
    }
    $('.js-filter-form').addClass('changedFilters').submit();
  }

  /**
   * @param {string} countryIsoCode2
   * @param {string} city
   * @param {function} callback
   */
  getCountryAndCityViewport(countryIsoCode2, city, callback) {
    var self = this;
    var address = city;
    var cacheKey = countryIsoCode2;
    if (address && address !== '') {
      cacheKey = countryIsoCode2 + '_' + address;
    } else {
      address = '';
    }

    var hasViewportCacheProperty = {}.hasOwnProperty.call(self.viewPortCache, cacheKey);
    if (hasViewportCacheProperty) {
      callback(self.viewPortCache[cacheKey]);
    } else {
      self.geoCoder.geocode({
        componentRestrictions: {
          country: countryIsoCode2
        },
        address: address
      }, (results, status) => {
        if (status === google.maps.GeocoderStatus.OK) {
          self.viewPortCache[cacheKey] = results[0].geometry.viewport;
          callback(self.viewPortCache[cacheKey]);
        }
      });
    }
  }

  /**
   * @param {string} city
   * @param {function} callback
   */
  getCityViewport(city, callback) {
    var self = this;
    var address = city;
    var cacheKey = 'more';
    if (address && address !== '') {
      cacheKey = 'more_' + address;
    } else {
      address = '';
    }

    var hasViewportCacheProperty = {}.hasOwnProperty.call(self.viewPortCache, cacheKey);
    if (hasViewportCacheProperty) {
      callback(self.viewPortCache[cacheKey]);
    } else {
      self.geoCoder.geocode({
        address: address
      }, (results, status) => {
        if (status === google.maps.GeocoderStatus.OK) {
          self.viewPortCache[cacheKey] = results[0].geometry.viewport;
          callback(self.viewPortCache[cacheKey]);
        }
      });
    }
  }

  /**
   * @returns {boolean}
   */
  isMayZoomOut() {
    return this.mayZoomOut;
  }

  /**
   * @param mayZoomOut
   */
  setMayZoomOut(mayZoomOut) {
    this.mayZoomOut = mayZoomOut;
  }
};
